module.exports = __webpack_public_path__ + "tenant-tagsets.52bcc6eed5e3aed9ed6aab4f448105ae.hashedasset.svg";